module.exports = __webpack_public_path__ + "img/__rocket02.211c4842.svg";